import React from "react";
import ExcelJS from "exceljs";

const ExcelQueryTraySubReport = ({ data }) => {
  const exportExcelFile = async () => {
    if (!Array.isArray(data) || data.length === 0) return;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Query Tray Report");

    worksheet.columns = [
      { header: "S.No", key: "serial", width: 8 },
      { header: "File No", key: "file_no", width: 16 },
      { header: "Law Hands Branch Name", key: "lh_branch_name", width: 22 },
      { header: "Bank Name", key: "bank_name", width: 28 },
      { header: "Product", key: "product", width: 14 },
      { header: "Grade", key: "grade", width: 10 },
      { header: "Bank Branch Name", key: "bank_branch_name", width: 22 },
      { header: "Borrower Name", key: "borrower_name", width: 28 },
      { header: "Property Owner Name", key: "owner_name", width: 30 },
      { header: "App Id", key: "app_id", width: 22 },
      { header: "Login Date", key: "login_date", width: 22 },
      { header: "Query Raised by", key: "query_raised_by", width: 22 },
      { header: "Query Raised Date & Time", key: "query_raised_dt", width: 28 },
      { header: "Query Details", key: "query_details", width: 36 },
      { header: "Move to Process Date & Time", key: "move_to_process_dt", width: 28 },
      { header: "Query Received Details", key: "query_received_details", width: 36 },
      { header: "Pending Query Details", key: "pending_query_details", width: 36 },
      { header: "Query Uploaded by", key: "query_uploaded_by", width: 24 },
      { header: "File Status", key: "file_status", width: 22 },
    ];

    worksheet.getRow(1).eachCell((cell) => {
      cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFF00" } };
      cell.font = { bold: true, size: 12 };
    });

    data.forEach((item, index) => {
      const row = worksheet.addRow({
        serial: index + 1,
        file_no: item.file_no || "",
        lh_branch_name: item.lh_branch_name || "",
        bank_name: item.bank_name || "",
        product: item.product || "",
        grade: item.grade || "",
        bank_branch_name: item.bank_branch_name || "",
        borrower_name: item.borrower_name || "",
        owner_name: item.owner_name || "",
        app_id: item.app_id || "",
        login_date: item.login_date || "",
        query_raised_by: item.query_raised_by || "",
        query_raised_dt: item.query_raised_dt || item.initial_query_raised_dt || item.query_date || "",
        query_details: item.query_details || item.initial_query_details || "",
        move_to_process_dt: item.move_to_process_dt || item.full_query_received_dt || "",
        query_received_details:
          item.query_received_details || item.fully_query_details || item.full_query_received_details || "",
        pending_query_details: item.pending_query_details || "",
        query_uploaded_by: item.query_uploaded_by || "",
        file_status: item.file_status || "",
      });

      row.eachCell((cell, colNumber) => {
        cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
        if ([14, 15, 16, 17].includes(colNumber)) {
          cell.alignment = { vertical: "top", horizontal: "left", wrapText: true };
        }
      });
    });

    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate().toString().padStart(2, "0")}-${(currentDate.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${currentDate.getFullYear()}`;
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = `Query-Tray-Subreport ${formattedDate}.xlsx`;
    anchor.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <button className="excel-download-btn" onClick={exportExcelFile}>
      Download as Excel
    </button>
  );
};

export default ExcelQueryTraySubReport;
